import { render, staticRenderFns } from "./ArtistAccount.vue?vue&type=template&id=9018b3ac&scoped=true&"
import script from "./ArtistAccount.vue?vue&type=script&lang=js&"
export * from "./ArtistAccount.vue?vue&type=script&lang=js&"
import style0 from "./ArtistAccount.vue?vue&type=style&index=0&id=9018b3ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9018b3ac",
  null
  
)

export default component.exports